import styled from 'styled-components';
import { PropertyCardDataWrapperMixin } from '../../mixins/components/PropertyCardDataWrapperMixin';
export var StyledPropertyCardDataWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardDataWrapper",
  componentId: "c11n-8-111-1__sc-hfbvv9-0"
})(["", ""], PropertyCardDataWrapperMixin);